/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUserRequestsIdSubmitMutationResponse,
  PostUserRequestsIdSubmitPathParams,
  PostUserRequestsIdSubmit400,
} from '../entities/PostUserRequestsIdSubmit'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUserRequestsIdSubmit } from '../api/postUserRequestsIdSubmit'
import { useMutation } from '@tanstack/react-query'

export const postUserRequestsIdSubmitMutationKey = () => [{ url: '/user-requests/{id}/submit' }] as const

export type PostUserRequestsIdSubmitMutationKey = ReturnType<typeof postUserRequestsIdSubmitMutationKey>

/**
 * @description Отправка заявки водителя таксопарка
 * @summary Отправка заявки водителя таксопарка
 * {@link /user-requests/:id/submit}
 */
export function usePostUserRequestsIdSubmit<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostUserRequestsIdSubmitMutationResponse,
      ResponseErrorConfig<PostUserRequestsIdSubmit400>,
      { id: PostUserRequestsIdSubmitPathParams['id'] },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUserRequestsIdSubmitMutationKey()

  return useMutation<
    PostUserRequestsIdSubmitMutationResponse,
    ResponseErrorConfig<PostUserRequestsIdSubmit400>,
    { id: PostUserRequestsIdSubmitPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return postUserRequestsIdSubmit(id, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}